<app-cosign-search
  [enableSign]="enableSign"
  (onSearch)="onSearch($event)"
  (onShowArchived)="onShowArchived($event)"
  (onClickSign)="onClickSign()"
  [selectionsCount]="selectedRowsToSign.length"
/>
<div class="documents-container overflow-y-auto">
      <thera-client-side-list
        [columnDefs]="columnDefs"
        [rowData]="cosignDocumentData"
        noRowsTemplate="No records found."
        (selectionChanged)="selectedForCoSign($event)"
        [rowSelection]="'multiple'" 
        [hideGridLines]="true"   
        [enablePagination]="showArchived"
        [suppressRowClickSelection]="true"
        [isRowSelectable]="isRowSelectable" 
        [getRowId]="getRowId"
      />
</div>